import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";

// Apply persisted theme BEFORE React mounts to avoid a light-mode flash on load.
try {
    const saved = localStorage.getItem("akm_theme");
    if (saved === "dark") document.documentElement.classList.add("dark");
    else if (saved === "light") document.documentElement.classList.remove("dark");
} catch { /* ignore */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: register only in production; dev builds skip to avoid stale cache pain.
if (process.env.NODE_ENV === "production") {
    registerServiceWorker();
}
